import { Page } from "@/models/page-models/Page";

export const CreateLoadingManifest: Page = {
  "path": "create-loading-manifest",
  "name": "Create Loading Manifest",
  "props": {
    "data": {
      "title": "Create Loading Manifest",
      "printable": "FALSE",
      "url": "create-loading-manifest",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedCustomer",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getFilteredCalloffs",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "filterCalloffs",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.filteredCalloffs"
                      },
                      "name": "getFilteredCalloffs"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetCalloffOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCalloffOrders"
                      },
                      "name": "resetCalloffOrders"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetlmOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getEmptyArray",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "resetlmOrders"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getCustomerData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/customers/{{fetchedData.selectedCustomer}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.customerDetails"
                      },
                      "name": "getCustomerData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyVatPercentage",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getVatPercentage",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyVatPercentage"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.pendingCalloffs.data",
                  "itemText": "customer.alias",
                  "itemValue": "customer._id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                }
              ]
            },
            {
              "name": "1a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedCalloff",
                  "label": "Select Calloff",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedCustomer}}",
                  "items": "fetchedData.filteredCalloffs",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,callOffDescription,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Add Calloff",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction":  {
                        "name": "copySelectedCalloff",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceFn",
                        "arg1Value": "findSelectedCalloff",
                        "arg2Key": "sourceTransformationFn",
                        "arg2Value": "createCallOffObject",
                        "arg3Key": "destinationVariable",
                        "arg3Value": "fetchedData.selectedCalloffOrders"
                      },
                      "name": "copySelectedCalloff"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "resetSelectedCalloff",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCalloff"
                      },
                      "name": "resetSelectedCalloff"
                    },
                    {
                      "executionOrder": 2,
                      "name": "getFilteredFgs"
                    }
                  ],
                  "disabled": "fn(NOT,{{fetchedData.selectedCalloff}})",
                  "showIf": "{{fetchedData.selectedCustomer}}",
                  "color": "primary"
                }
              ],
              "showIf": "fn(NOT,fn(LENGTH,{{fetchedData.selectedCalloffOrders}}))"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.selectedCalloffOrders",
                  "label": "Finished Goods",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.selectedCalloffOrders}})",
                  "items": "fetchedData.filteredCalloffs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Calloff #"
                    },
                    {
                      "value": "__item.customerPO",
                      "text": "Customer PO#"
                    },
                    {
                      "value": "__item.customer",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "__item.product",
                      "text": "Product",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "CallOff Quantity",
                      "type": "text"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "Calloff FOC",
                      "type": "text"
                    },
                    {
                      "value": "__item.unit.unit2",
                      "text": "Unit"
                    },
                    {
                      "value": "__item.lineNumber",
                      "text": "Customer Schedule Line #",
                      "type": "text"
                    },
                    {
                      "value": "__item.itemNumber",
                      "text": "Customer Item #",
                      "type": "text"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "callOff._id",
                  "itemKey": "_id",
                  "canDelete": true,
                  "executeOnDelete": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetCalloffOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCalloffOrders"
                      },
                      "name": "resetCalloffOrders"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetlmOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getEmptyArray",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "resetlmOrders"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Select Finished Good(s) to be loaded for the above Calloff",
                  "showIf": "fn(LENGTH,{{fetchedData.selectedCalloffOrders}})"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedGood",
                  "label": "Select FG",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.selectedCalloffOrders}})",
                  "items": "fetchedData.filteredGoods",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,lmOrderDescription,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Add FG",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction":  {
                        "name": "addFG",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceFn",
                        "arg1Value": "findSelectedFgDetails",
                        "arg2Key": "sourceTransformationFn",
                        "arg2Value": "createTableVariableObject",
                        "arg3Key": "destinationVariable",
                        "arg3Value": "fetchedData.lmOrders"
                      },
                      "name": "addFG"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "resetSelectedFg",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedGood"
                      },
                      "name": "resetSelectedFg"
                    },
                    {
                      "executionOrder": 2,
                      "name": "getFilteredFgs"
                    }
                  ],
                  "disabled": "fn(NOT,{{fetchedData.selectedGood}})",
                  "showIf": "fn(LENGTH,{{fetchedData.selectedCalloffOrders}})",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.lmOrders",
                  "label": "Finished Goods",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.selectedCalloffOrders}})",
                  "items": "fetchedData.goods.data",
                  "headers": [
                    {
                      "value": "__item.factoryTicket.order._id",
                      "text": "Order"
                    },
                    {
                      "value": "__item.factoryTicket.order.customerPO",
                      "text": "Customer PO#"
                    },
                    {
                      "value": "__item.factoryTicket.order.customer.name",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                    },
                    {
                      "value": "__item.factoryTicket.order.product",
                      "text": "Product",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Available Quantity",
                      "type": "text"
                    },
                    {
                      "value": "__item.foc",
                      "text": "FOC",
                      "type": "text"
                    },
                    {
                      "value": "__item.factoryTicket.order.product.unit.unit2",
                      "text": "Unit"
                    },
                    {
                      "value": "__item.factoryTicket.order.product.packingMode",
                      "text": "Packing Detail",
                      "formula": "fn(HELPER_FN,packingMode,{{__item.factoryTicket.order.product.packingMode}})"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "fg._id",
                  "itemKey": "_id",
                  "canDelete": true,
                  "executeOnDelete": [
                    {
                      "executionOrder": 2,
                      "name": "getFilteredFgs"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Please Verify the Calloff quantities and the Order Quantites are equal",
                  "showIf": "fn(LOGICAL,fn(ARRAY_SUM,{{{{__item.quantity}} + {{__item.foc}}}},{{fetchedData.lmOrders}}),!=,fn(ARRAY_SUM,{{{{__item.quantity}} + {{__item.FOC}}}},{{fetchedData.selectedCalloffOrders}}))"
                }
              ],
              "showIf": "fn(LENGTH,{{fetchedData.lmOrders}})"
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add Calloff To Loading Manifest",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyResolvedOrdersForCalloff",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "fetchedData.lmOrders",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.resolvedOrdersForCalloff",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getLmOrderObject"
                      },
                      "name": "copyResolvedOrdersForCalloff"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyResolvedCalloffForPreview",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "fetchedData.selectedCalloffOrders.0",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.callOffs",
                        "arg3Key": "sourceTransformationFn",
                        "arg3Value": "getResolvedCalloffObject"
                      },
                      "name": "copyResolvedCalloffForPreview"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "resetCalloffOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCalloffOrders"
                      },
                      "name": "resetCalloffOrders"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "resetlmOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getEmptyArray",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "resetlmOrders"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(ARRAY_SUM,{{{{__item.quantity}} + {{__item.foc}}}},{{fetchedData.lmOrders}}),!=,fn(ARRAY_SUM,{{{{__item.quantity}} + {{__item.FOC}}}},{{fetchedData.selectedCalloffOrders}}))",
                  "showIf": "fn(LENGTH,{{fetchedData.lmOrders}})",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "label",
                  "label": "LM/Invoice Preview",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "class": "text-h5"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "table",
                  "label": "LM/Invoice Preview",
                  "variable": "fetchedData.callOffs",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "items": "fetchedData.callOffs",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.callOffs}}))"
                    },
                    {
                      "value": "__item.callOff._id",
                      "text": "Order #",
                      "type": "formula",
                      "formula": "{{__item.callOff.product._id}}\\n{{__item.callOff._id}}"
                    },
                    {
                      "value": "__item.callOff.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(HELPER_FN,productAlias,{{__item.callOff.product}}),fn(CONDITIONAL,fn(LOGICAL,{{__item.lineNumber}},>,0),fn(CONCAT, (,{{__item.lineNumber}},-,{{__item.itemNumber}},)),))",
                      "width": 130
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity",
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC"
                    },
                    {
                      "value": "__item.callOff.unit.unit2",
                      "text": "Unit"
                    },
                    {
                      "value": "__item.callOff.unitPrice",
                      "text": "Unit Price SAR"
                    },
                    {
                      "value": "__item.value",
                      "text": "Sub Total",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.callOff.unitPrice}},{{__item.quantity}}))",
                      "align": "center"
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %"
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.callOff.unitPrice}},{{__item.quantity}},{{fetchedData.vatPercent}},0.01))"
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.callOff.unitPrice}},{{__item.quantity}},fn(SUM,100,{{fetchedData.vatPercent}}),0.01))"
                    },
                    {
                      "value": "additionalCharges",
                      "text": "Additional Charges",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,{{__item.callOff.additionalCharges}},>,0),fn(CONCAT,{{__item.callOff.additionalChargesType}},: ,fn(HELPER_FN,currency,{{__item.callOff.additionalCharges}})),N/A)"
                    },
                    {
                      "value": "actions",
                      "text": "Actions"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "callOff._id",
                  "itemKey": "callOff._id",
                  "canDelete": true,
                  "showActions": false
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "variable": "fetchedData.callOffs",
                  "label": "Sub Total",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "config": {
                    "totalFormula": "fn(MULTIPLY,fn(SUM,100,{{fetchedData.vatPercent}}),0.01,fn(KEYED_ARRAY_SUM,fn(SUM,{{__arrayItem.callOff.additionalCharges}},fn(MULTIPLY,{{__arrayItem.callOff.unitPrice}},{{__arrayItem.quantity}})),{{fetchedData.callOffs}}))",
                    "subTotalFormula": "fn(KEYED_ARRAY_SUM,fn(SUM,{{__arrayItem.callOff.additionalCharges}},fn(MULTIPLY,{{__arrayItem.callOff.unitPrice}},{{__arrayItem.quantity}})),{{fetchedData.callOffs}})",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Vehicle Details",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.typeOfDelivery",
                  "label": "Type of Delivery",
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "items": "[\"Senddex\",\"Aramex\",\"Naqel\",\"Smsa\",\"Company Driver\",\"Third Party\",\"Customer Pickup\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "formData.trackingNo",
                  "label": "Tracking No",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.driverName",
                  "label": "Driver Name",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.plateNumber",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "label": "Plate Number",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Loading Manifest",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyUpdatedCalloffArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "fetchedData.callOffs",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.callOffs",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getCalloffObject"
                      },
                      "name": "copyUpdatedCalloffArray"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "createLoadingManifest",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/loadingmanifest/createLoadingManifest",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "fnsAfterSubmit",
                        "arg4Value": "resetCustomerId"
                      },
                      "name": "createLoadingManifest"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LENGTH,{{fetchedData.callOffs}})",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getFinishedGoods",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/goods/fg?hideEmpty=1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.goods"
        },
        "name": "getFinishedGoods"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getPendingCalloffs",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/get-pending-call-off",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingCalloffs"
        },
        "name": "getPendingCalloffs"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyCustomersArray",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getCustomersArray",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyCustomersArray"
      },
      {
        "executionOrder": 3,
        "name": "getFilteredFgs"
      }
    ],
    "functions": [
      {
        "name": "filterFgGoods",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.goods.data",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(LOGICAL,fn(LOGICAL,{{__item.factoryTicket._id}},>,0),&&,fn(LOGICAL,fn(LOGICAL,{{__item.factoryTicket.order.customer._id}},==,{{fetchedData.selectedCustomer}}),&&,fn(LOGICAL,{{__item.factoryTicket.order.product._id}},==,{{fetchedData.selectedCalloffOrders.0.callOff.product._id}})))"
      },
      {
        "name": "getFilteredFgs",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterFgGoods",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.filteredGoods"
      },
      {
        "name": "findSelectedFgDetails",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.goods.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedGood"
      },
      {
        "name": "findSelectedCalloff",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.filteredCalloffs",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedCalloff"
      },
      {
        "name": "createCallOffObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "callOff": "{{__selectedObject}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}"
        },
        "useFormula": true
      },
      {
        "name": "createTableVariableObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "order": "{{__selectedObject.factoryTicket.order._id}}",
          "orderDetails": "{{__selectedObject.factoryTicket.order}}",
          "factoryTicket": "{{__selectedObject.factoryTicket._id}}",
          "fg": "{{__selectedObject}}",
          "quantity": "fn(HELPER_FN,kgToSellingUnitQuantity,{{__selectedObject.factoryTicket.order}},{{__selectedObject}},{{__selectedObject.location.Warehouse.totalQuantity}})"
        },
        "useFormula": true
      },
      {
        "name": "getLmOrderObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "order": "{{__selectedObject.order}}",
          "factoryTicket": "{{__selectedObject.factoryTicket}}",
          "quantity": "fn(HELPER_FN,sellingUnitQuantityToKg,{{__selectedObject.fg}},{{__selectedObject.quantity}},{{__selectedObject.fg.factoryTicket.order.product.unit.unit2}},{{__selectedObject.fg.location.Warehouse.totalQuantity}})",
          "FOC": "fn(HELPER_FN,sellingUnitQuantityToKg,{{__selectedObject.fg}},{{__selectedObject.foc}},{{__selectedObject.fg.factoryTicket.order.product.unit.unit2}},{{__selectedObject.fg.location.Warehouse.totalQuantity}})"
        },
        "useFormula": true
      },
      {
        "name": "getResolvedCalloffObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "callOff": "{{__selectedObject.callOff}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}",
          "lineNumber": "{{__selectedObject.lineNumber}}",
          "itemNumber": "{{__selectedObject.itemNumber}}",
          "orders": "{{fetchedData.resolvedOrdersForCalloff}}"
        },
        "useFormula": true
      },
      {
        "name": "getCalloffObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "callOff": "{{__selectedObject.callOff._id}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}",
          "lineNumber": "{{__selectedObject.lineNumber}}",
          "itemNumber": "{{__selectedObject.itemNumber}}",
          "orders": "{{__selectedObject.orders}}"
        },
        "useFormula": true
      },
      {
        "name": "getCustomersArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customers": "fn(HELPER_FN,customerArrayFromFg,{{fetchedData.goods.data}})"
        },
        "useFormula": true
      },
      {
        "name": "resetCustomerId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedCustomer"
      },
      {
        "name": "getEmptyArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "lmOrders": []
        },
        "staticObject": true
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{fetchedData.customerDetails.data.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "filterCalloffs",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.pendingCalloffs.data",
        "arg2Key": "formulaCondition",
        "arg2Value": "fn(LOGICAL,{{__item.customer._id}},==,{{fetchedData.selectedCustomer}})"
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 70
}